import type { DatasetSummary, ProfileDatasetSection } from '../../types/datasetTypes';

export const isTableSourceDataset = (dataset: DatasetSummary): boolean => (
  dataset.kind !== 'list' && dataset.kind !== 'merge'
);

export const getTableDatasetsInWorkspace = (
  sections: ProfileDatasetSection[],
  rootFolderId: string,
): DatasetSummary[] => (
  sections
    .filter((section) => section.rootFolderId === rootFolderId)
    .flatMap((section) => section.datasets)
    .filter(isTableSourceDataset)
);
